<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Number of Loan Applications"
                                type="gradient-red"
                                :sub-title=formatNumber(userSummary.no_of_loan_applications)
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Number of Approved Loans"
                                type="gradient-orange"
                                :sub-title=formatNumber(userSummary.number_of_loans)
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Repayment Amount"
                                type="gradient-red"
                                :sub-title=formatCost(userSummary.total_loan_repayment)
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Approved Amount"
                                type="gradient-orange"
                                :sub-title=formatCost(userSummary.total_approved_amount)
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <stats-card title="Total Loan Amount Balance"
                                type="gradient-green"
                                :sub-title=formatCost(userSummary.total_loan_balance)
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                    </stats-card>

                </div>
                
            </div>
        </base-header>

    </div>
</template>
<script>
  export default {
    name: 'userDashboard',
    methods: {
        formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
             formatNumber(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return result;
                } else {
                    return '0';
                }
            },
    },
    created(){
      const userPublicId = localStorage.getItem('pdis');
      this.$store.dispatch('notifications_function', userPublicId);
      this.$store.dispatch('userSummary_function');
      
      var str = localStorage.getItem('name');
      var matches = str.match(/\b(\w)/g); 
      var acronym = matches.join(''); 
      localStorage.setItem('acronym', acronym)
    },
  };
</script>
<style></style>
